import React from 'react'
import { BrandLogo, CountBadge, TopNavigation } from '@yanolja-rnd/nol-design-system'
import { IcArrowback, IcHome } from '@yanolja-rnd/nol-icons'
import { getDeviceTypeFromUserAgent } from '~/api/util'
import { IcCart, IcFavorite, IcMy, IcClock } from '@yanolja-rnd/nol-icons'
import { useNavigation } from '~/app/utils/use-navigation'

interface CartHeaderProps {
  cartCount: number
}

export const Header: React.FC<CartHeaderProps> = ({ cartCount }) => {
  const deviceType = getDeviceTypeFromUserAgent()

  const {
    onHomeClick,
    onBackClick,
    onMyPageClick,
    onWishlistClick,
    onCartClick,
    onRecentProductClick,
  } = useNavigation()

  return (
    <>
      {/* 모바일 헤더 */}
      <header
        className={
          'fixed top-0 z-30 w-full max-w-mobile-size bg-static-white pc:hidden pc:max-w-none'
        }
      >
        <TopNavigation
          leftButton={{
            'aria-label': '뒤로 가기',
            onClick: onBackClick,
            icon: <IcArrowback />,
          }}
          rightButtons={[
            {
              type: 'Icon',
              button: {
                'aria-label': 'Home',
                icon: <IcHome />,
                onClick: onHomeClick,
              },
            },
          ]}
          title={'장바구니'}
          deviceType={deviceType}
        />
      </header>
      {/* PC 헤더 */}
      <header className="fixed left-0 right-0 top-0 z-30 hidden h-100 w-full flex-col items-center bg-static-white pc:flex">
        <div className="flex h-full w-full max-w-pc-with-swiper-btn justify-between px-25">
          <button type="button" onClick={onHomeClick} className="flex items-center justify-center">
            <BrandLogo className="w-98" />
          </button>
          <div className="mt-8 flex gap-x-2 *:flex *:w-80 *:flex-col *:items-center">
            <button type="button" onClick={onMyPageClick}>
              <div className="grid size-56 place-items-center">
                <IcMy width={32} height={32} />
              </div>
              <span className="typography-body-14-bold">마이</span>
            </button>
            <button type="button" onClick={onWishlistClick}>
              <div className="grid size-56 place-items-center">
                <IcFavorite width={32} height={32} />
              </div>
              <span className="typography-body-14-bold">찜</span>
            </button>
            <button type="button" onClick={onCartClick}>
              <div className="relative grid size-56 place-items-center">
                <IcCart width={32} height={32} />
                {cartCount > 0 && (
                  <CountBadge className="absolute right-6 top-6 h-20 w-20 bg-fill-primary-main">
                    <span className="text-static-white typography-body-12-bold">{cartCount}</span>
                  </CountBadge>
                )}
              </div>
              <span className="typography-body-14-bold">장바구니</span>
            </button>
            <button type="button" onClick={onRecentProductClick}>
              <div className="grid size-56 place-items-center">
                <IcClock width={32} height={32} />
              </div>
              <span className="typography-body-14-bold">최근 본 상품</span>
            </button>
          </div>
        </div>
        {/* 그라데이션 라인 */}
        <div className="absolute bottom-0 left-0 h-1 w-full bg-[linear-gradient(258deg,#4AB0F9_0%,#6181EA_33%,#3549FF_66%,#8249D8_100%)]" />
      </header>

      {/* 헤더 높이만큼 띄우기 */}
      <div className="h-52 pc:h-100" />
    </>
  )
}
